module.exports = __webpack_public_path__ + "static/media/fullscreen-icon-light.89cdaa18.svg";